/* eslint-disable max-lines-per-function */
import {
  Button,
  Command,
  CommandGroup,
  CommandItem,
  CommandSeparator,
  Popover,
  PopoverContent,
  PopoverTrigger,
  ScrollArea,
} from '@e2n/ui';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectCommandItemValues } from '@/domain/termine/features/Calendar/shared/CalendarSelectCommandItemValues';
import { cn } from '@/lib/utils';
import {
  faCalendarStar,
  faPlusLarge,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function CalendarSelect() {
  const { kalender, selectedKalenderIds, setSelectedKalenderIds } =
    useCalendarContext();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  function handleSelect(kalenderId: string) {
    if (selectedKalenderIds.includes(kalenderId)) {
      setSelectedKalenderIds(
        selectedKalenderIds.filter((id) => id !== kalenderId),
      );
    } else {
      setSelectedKalenderIds([...selectedKalenderIds, kalenderId]);
    }
  }
  return (
    <>
      {!kalender ? (
        ''
      ) : (
        <Popover onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline-secondary"
              size="icon"
              className={cn(open ? 'bg-neutrals-300' : '')}>
              <FontAwesomeIcon icon={faCalendarStar} />
            </Button>
          </PopoverTrigger>

          <PopoverContent
            className="bg-white w-64 items-stretch p-1"
            align="end"
            side="bottom"
            sideOffset={2}>
            <ScrollArea className="overflow-scroll max-h-80" data-vaul-no-drag>
              <Command className="w-full">
                <CommandGroup className="flex flex-col gap-2 justify-betweens w-full">
                  {kalender.length > 1 &&
                    kalender.map((kalender) => (
                      <CommandItem
                        className="transition-colors text-sm font-normal"
                        key={kalender.id}
                        value={kalender.name}
                        onSelect={() => handleSelect(kalender.id)}>
                        <CalendarSelectCommandItemValues
                          kalenderItem={kalender}
                          selectedKalenderIds={selectedKalenderIds}
                        />
                      </CommandItem>
                    ))}
                  {kalender.length > 1 && <CommandSeparator className="my-1" />}
                  <CommandItem
                    asChild
                    className="transition-colors text-sm flex items-center gap-2 p-2 rounded-sm font-semibold">
                    <Link to="/termine/kalender/uebersicht">
                      <FontAwesomeIcon
                        icon={faPlusLarge}
                        className="h-4 w-4 text-primary-blue-600"
                      />
                      <span className="text-primary-blue-600">
                        {t('domain.termine.createTerminCalendar')}
                      </span>
                    </Link>
                  </CommandItem>
                </CommandGroup>
              </Command>
            </ScrollArea>
          </PopoverContent>
        </Popover>
      )}
    </>
  );
}
